// Auto-generated builder quote seeds from Julius Avenue costing analysis
// Generated: 2026-05-25
// Source: scripts/parse_builder_quotes.py → extracted JSON

import type { BuilderQuote } from "../types";

export const JULIUS_BUILDER_QUOTES_SEED: BuilderQuote[] = [
  {
    id: "adco-2026-01",
    builderName: "ADCO Constructions",
    bidDate: "2026-01-15",
    reportedTpc: 144621146.28,
    notes:
      "Full inclusive TPC. Design fees (~4.5%), prelims (~22%), contingency (5%), margin included. Fitout rate $2,050/m\u00b2 covers 22 trade items.",
    scope: [
      {
        itemKey: "construction_b1",
        label: "10 Julius Avenue \u2014 Construction",
        dollarAmount: 46232657.0,
        per: "building",
        buildingId: "b1",
      },
      {
        itemKey: "contingency_b1",
        label: "10 Julius Avenue \u2014 Contingency (5%)",
        dollarAmount: 2311632.85,
        per: "building",
        buildingId: "b1",
      },
      {
        itemKey: "design_fees_b1",
        label: "10 Julius Avenue \u2014 Design fees",
        dollarAmount: 2912657.39,
        per: "building",
        buildingId: "b1",
      },
      {
        itemKey: "prelims_b1",
        label: "10 Julius Avenue \u2014 Preliminaries & logistics",
        dollarAmount: 10291389.45,
        per: "building",
        buildingId: "b1",
      },
      {
        itemKey: "margin_b1",
        label: "10 Julius Avenue \u2014 Margin",
        dollarAmount: 3087416.83,
        per: "building",
        buildingId: "b1",
      },
      {
        itemKey: "construction_b2",
        label: "10A Julius Avenue \u2014 Construction",
        dollarAmount: 12788540.0,
        per: "building",
        buildingId: "b2",
      },
      {
        itemKey: "contingency_b2",
        label: "10A Julius Avenue \u2014 Contingency (5%)",
        dollarAmount: 639427.0,
        per: "building",
        buildingId: "b2",
      },
      {
        itemKey: "design_fees_b2",
        label: "10A Julius Avenue \u2014 Design fees",
        dollarAmount: 805678.02,
        per: "building",
        buildingId: "b2",
      },
      {
        itemKey: "prelims_b2",
        label: "10A Julius Avenue \u2014 Preliminaries & logistics",
        dollarAmount: 2846729.0,
        per: "building",
        buildingId: "b2",
      },
      {
        itemKey: "margin_b2",
        label: "10A Julius Avenue \u2014 Margin",
        dollarAmount: 214591.7,
        per: "building",
        buildingId: "b2",
      },
      {
        itemKey: "construction_b3",
        label: "12A Julius Avenue \u2014 Construction",
        dollarAmount: 21649610.0,
        per: "building",
        buildingId: "b3",
      },
      {
        itemKey: "contingency_b3",
        label: "12A Julius Avenue \u2014 Contingency (5%)",
        dollarAmount: 1082480.5,
        per: "building",
        buildingId: "b3",
      },
      {
        itemKey: "design_fees_b3",
        label: "12A Julius Avenue \u2014 Design fees",
        dollarAmount: 1363925.43,
        per: "building",
        buildingId: "b3",
      },
      {
        itemKey: "prelims_b3",
        label: "12A Julius Avenue \u2014 Preliminaries & logistics",
        dollarAmount: 4819203.19,
        per: "building",
        buildingId: "b3",
      },
      {
        itemKey: "margin_b3",
        label: "12A Julius Avenue \u2014 Margin",
        dollarAmount: 363280.46,
        per: "building",
        buildingId: "b3",
      },
      {
        itemKey: "construction_b4",
        label: "12B  Julius Avenue \u2014 Construction",
        dollarAmount: 23682545.0,
        per: "building",
        buildingId: "b4",
      },
      {
        itemKey: "contingency_b4",
        label: "12B  Julius Avenue \u2014 Contingency (5%)",
        dollarAmount: 1184127.25,
        per: "building",
        buildingId: "b4",
      },
      {
        itemKey: "design_fees_b4",
        label: "12B  Julius Avenue \u2014 Design fees",
        dollarAmount: 1492000.33,
        per: "building",
        buildingId: "b4",
      },
      {
        itemKey: "prelims_b4",
        label: "12B  Julius Avenue \u2014 Preliminaries & logistics",
        dollarAmount: 5271734.52,
        per: "building",
        buildingId: "b4",
      },
      {
        itemKey: "margin_b4",
        label: "12B  Julius Avenue \u2014 Margin",
        dollarAmount: 1581520.36,
        per: "building",
        buildingId: "b4",
      },
    ],
    exclusions: [],
    scoreDocumentationDepth: {
      D1_tradeDetail: 4,
      D2_quantitiesRates: 4,
      D3_scheduleAlignment: 3,
      D4_exclusionsCoverage: 5,
      D5_sourceVerification: 4,
      D7_rateAlignment: 3,
      D8_contingencyTransparency: 4,
    },
  },
  {
    id: "buildcorp-2026-01",
    builderName: "BuildCorp",
    bidDate: "2026-01-20",
    reportedTpc: 143734363,
    excludedDesignFees: true,
    excludedDesignFeesPct: 0.045,
    notes:
      "TPC excludes design fees and escalation. Includes prelims (23% of net trade), combined design (2%) + construction (3%) contingency, margin & overheads (5%). Net trade $85.3M + project factors $21.4M.",
    scope: [
      {
        itemKey: "net_trade_cost",
        label: "Net trade cost (structure, envelope, fitout, services)",
        dollarAmount: 85287432,
        per: "project",
      },
      {
        itemKey: "project_site_factors",
        label:
          "Project & site specific factors (demolition, landscaping, outdoor areas, etc.)",
        dollarAmount: 21393616,
        per: "project",
      },
      {
        itemKey: "preliminaries",
        label: "Preliminaries (23% of net trade)",
        dollarAmount: 24536641,
        per: "project",
      },
      {
        itemKey: "design_contingency",
        label: "Design contingency (2%)",
        dollarAmount: 2133621,
        per: "project",
      },
      {
        itemKey: "construction_contingency",
        label: "Construction contingency (3%)",
        dollarAmount: 3200431,
        per: "project",
      },
      {
        itemKey: "margin_overheads",
        label: "Margin & overheads (5%)",
        dollarAmount: 7182622,
        per: "project",
      },
    ],
    exclusions: [
      {
        itemKey: "design_fees",
        label: "Design fees",
        status: "excluded",
        notes:
          "Excluded per clarifications. Covered by excludedDesignFeesPct (4.5%).",
      },
      {
        itemKey: "HV_S73_services",
        label: "HV / S73 services",
        status: "excluded",
        dollarAmount: 800000,
        notes: "Authority works excluded until requirements known.",
      },
      {
        itemKey: "ESD_code_compliance_upgrades",
        label: "ESD / code compliance upgrades",
        status: "excluded",
        dollarAmount: 1200000,
        notes: "No allowance for building upgrades for code compliance or ESD.",
      },
      {
        itemKey: "HAZMAT_removal",
        label: "HAZMAT removal",
        status: "excluded",
        dollarAmount: 500000,
        notes: "No allowance for removal or management of HAZMAT.",
      },
      {
        itemKey: "escalation",
        label: "Cost escalation allowance",
        status: "excluded",
        dollarAmount: 2000000,
        notes: "Excluded per clarifications. Escalation factor applied = 0%.",
      },
    ],
    scoreDocumentationDepth: {
      D1_tradeDetail: 4,
      D2_quantitiesRates: 4,
      D3_scheduleAlignment: 4,
      D4_exclusionsCoverage: 3,
      D5_sourceVerification: 4,
      D7_rateAlignment: 3,
      D8_contingencyTransparency: 4,
    },
  },
  {
    id: "versatile-2026-01",
    builderName: "Versatile Constructions",
    bidDate: "2026-01-10",
    reportedTpc: 100060180.66,
    excludedDesignFees: true,
    excludedDesignFeesPct: 0.045,
    excludedContingencyPct: 0.05,
    notes:
      "TPC excludes design fees, contingency, and consultant fees. Includes prelims (15%), OH (3%), margin (5%). Structural strengthening ($5M + on-costs = $6.2M) is School Contribution but INCLUDED in builder's $100.06M total.",
    scope: [
      {
        itemKey: "construction_12_and_12a_julius_junior_school",
        label: "12A + 12B Julius \u2014 Junior School construction",
        dollarAmount: 17793737.24,
        per: "building",
        buildingId: "b3",
      },
      {
        itemKey: "prelims_12_and_12a_julius_junior_school",
        label: "12A + 12B Julius \u2014 Preliminaries (15%)",
        dollarAmount: 2669060.59,
        per: "building",
        buildingId: "b3",
      },
      {
        itemKey: "external_works_associated_outdoor_areas",
        label: "External works \u2014 Associated Outdoor Area's",
        dollarAmount: 900000.0,
        per: "project",
      },
      {
        itemKey: "construction_10_julius_senior",
        label: "10A Julius \u2014 Senior School construction",
        dollarAmount: 7312306.23,
        per: "building",
        buildingId: "b2",
      },
      {
        itemKey: "prelims_10_julius_senior",
        label: "10A Julius \u2014 Preliminaries (15%)",
        dollarAmount: 1096845.93,
        per: "building",
        buildingId: "b2",
      },
      {
        itemKey: "construction_10_julius_sports_and_theatre",
        label: "10 Julius \u2014 Sports & Theatre construction",
        dollarAmount: 47645970.16,
        per: "building",
        buildingId: "b1",
      },
      {
        itemKey: "prelims_10_julius_sports_and_theatre",
        label: "10 Julius \u2014 Preliminaries (15%)",
        dollarAmount: 7146895.52,
        per: "building",
        buildingId: "b1",
      },
      {
        itemKey: "external_works_associated_outdoor_areas",
        label: "External works \u2014 Associated Outdoor Area's",
        dollarAmount: 1800000.0,
        per: "project",
      },
      {
        itemKey: "construction_structural_strengthening",
        label: "Structural strengthening (school-sponsored)",
        dollarAmount: 5000000.0,
        per: "project",
      },
      {
        itemKey: "prelims_structural_strengthening",
        label: "Structural strengthening \u2014 Preliminaries (15%)",
        dollarAmount: 750000.0,
        per: "project",
      },
      {
        itemKey: "overheads",
        label: "Overheads (3%)",
        dollarAmount: 2775594.47,
        per: "project",
      },
      {
        itemKey: "margin",
        label: "Margin (5%)",
        dollarAmount: 4764770.51,
        per: "project",
      },
    ],
    exclusions: [
      {
        itemKey: "design_fees",
        label: "Design fees",
        status: "excluded",
        notes: "Excluded from TPC. Covered by excludedDesignFeesPct (4.5%).",
      },
      {
        itemKey: "contingency",
        label: "Contingency",
        status: "excluded",
        notes: "Excluded from TPC. Covered by excludedContingencyPct (5%).",
      },
      {
        itemKey: "consultant_fees",
        label: "Consultant fees",
        status: "excluded",
        dollarAmount: 300000,
        notes: "Column shows 'None' in estimate; estimated at $300K.",
      },
    ],
    scoreDocumentationDepth: {
      D1_tradeDetail: 3,
      D2_quantitiesRates: 3,
      D3_scheduleAlignment: 3,
      D4_exclusionsCoverage: 3,
      D5_sourceVerification: 3,
      D7_rateAlignment: 3,
      D8_contingencyTransparency: 3,
      preliminaryFlag: "no_rlb_benchmark",
    },
  },
];

// Like-for-like TPC verification:
//   ADCO Constructions: reported $144,621,146.28 → LFL $144,621,146.28
//   BuildCorp: reported $143,734,363.00 → LFL $154,702,409.34
//   Versatile Constructions: reported $100,060,180.66 → LFL $109,865,897.82
